// Measurements + per-client metrics API.
import { http } from "./http";
import type { Measurement, MeasurementInput, MetricsSummary } from "./types";

export const measurementsApi = {
  list: (clientId: number, signal?: AbortSignal) =>
    http.get<Measurement[]>(
      `/clients/${clientId}/measurements`,
      undefined,
      signal,
    ),
  add: (clientId: number, body: MeasurementInput) =>
    http.post<Measurement>(`/clients/${clientId}/measurements`, body),
  /** KPI metrics + chart series (engine Results serialized). */
  metrics: (clientId: number, signal?: AbortSignal) =>
    http.get<MetricsSummary>(
      `/clients/${clientId}/metrics`,
      undefined,
      signal,
    ),
};
